import comp from "./ConfigureColumnsWrapper";
export default comp;
